import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import PropTypes from 'prop-types';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import QueryParamsProxy from '../../utils/queryParamProxy';
import Utils from '../../utils';
import RouteParamConstants, { PurchaseFinishedResults, PurchaseTypes } from '../../utils/routeParamConstants';
import SettingsScreensEnum from '../Settings/SettingsScreensEnum';
import ShopInterface from '../../api/ShopInterface';
import InboxMessagesProvider from '../../components/InboxMessagesProvider';
import Screens from '../index';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { PaymentProviders } from '../../utils/paymentProviders';
import { KYC_STATUS } from '../../utils/kyc/Constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import store from '../../state/store';

var PurchaseFlow = /*#__PURE__*/function (_Component) {
  function PurchaseFlow(props) {
    var _this2;

    _classCallCheck(this, PurchaseFlow);

    _this2 = _callSuper2(this, PurchaseFlow, [props]);

    _this2._nextHandle = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(success, validatedData) {
        var addressAvailable,
            _this2$state,
            stage,
            form,
            promoReward,
            promoCode,
            purchaseType,
            packageId,
            dynamicTriggeredSaleId,
            statePackage,
            _this2$props,
            setCardNickname,
            setPrePurchaseRoute,
            navigation,
            setPrePurchaseRouteParams,
            setPromoCode,
            formUrl,
            KYCResult,
            redirecturl,
            ptype,
            buyItemParams,
            response,
            newStage,
            cardNickname,
            routeParams,
            activeRouteState,
            activeRouteStateParams,
            gid,
            _ptype,
            billingInfo,
            _buyItemParams,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                addressAvailable = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                _this2$state = _this2.state, stage = _this2$state.stage, form = _this2$state.form, promoReward = _this2$state.promoReward, promoCode = _this2$state.promoCode, purchaseType = _this2$state.purchaseType, packageId = _this2$state.packageId, dynamicTriggeredSaleId = _this2$state.dynamicTriggeredSaleId, statePackage = _this2$state.package;
                _this2$props = _this2.props, setCardNickname = _this2$props.setCardNickname, setPrePurchaseRoute = _this2$props.setPrePurchaseRoute, navigation = _this2$props.navigation, setPrePurchaseRouteParams = _this2$props.setPrePurchaseRouteParams, setPromoCode = _this2$props.setPromoCode, formUrl = _this2$props.formUrl, KYCResult = _this2$props.KYCResult;

                _this2.setState({
                  validatedStage: stage
                });

                if (!success) {
                  _context.next = 64;
                  break;
                }

                redirecturl = "https://".concat(window.location.hostname, "/").concat(Screens.FinishWebPurchase, "?fix=me");

                if (window.location.hostname === 'localhost') {
                  redirecturl = "https://".concat(window.location.hostname, ":3000/").concat(Screens.FinishWebPurchase, "?fix=me");
                }

                if (!addressAvailable) {
                  _context.next = 27;
                  break;
                }

                ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : PurchaseTypes.CONSUMABLE;
                buyItemParams = {
                  ptype: ptype,
                  currpkgid: packageId,
                  redirecturl: redirecturl
                };
                buyItemParams.address1 = form.billingInfoAddress || validatedData.address1;
                buyItemParams.address2 = form.billingInfoAddress2 || validatedData.address2 || '';
                buyItemParams.city = form.billingInfoCity || validatedData.city;
                buyItemParams.country = form.billingInfoCountry || validatedData.country;
                buyItemParams.state = form.billingInfoState || validatedData.state;
                buyItemParams.zip = form.billingInfoZip || validatedData.zip;

                if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'ti' && KYCResult !== KYC_STATUS.PASS) {
                  buyItemParams.firstname = form.billingInfoFirstname || validatedData.firstName;
                  buyItemParams.lastname = form.billingInfoLastname || validatedData.lastName;
                  buyItemParams.year = form.billingInfoYear || validatedData.year;
                  buyItemParams.month = form.billingInfoMonth || validatedData.month;
                  buyItemParams.day = form.billingInfoDay || validatedData.day;
                }

                _context.next = 19;
                return ShopInterface.buyItem.sendAddressInfo(buyItemParams);

              case 19:
                response = _context.sent;

                if (!(response && response.success)) {
                  _context.next = 25;
                  break;
                }

                _this2.props.setFormUrl(response.formurl);

                _this2.props.showCustomModal(false);

                _context.next = 27;
                break;

              case 25:
                _this2.setState({
                  errorMessage: response.error
                });

                return _context.abrupt("return", null);

              case 27:
                newStage = stage + 1;

                if (validatedData && validatedData !== undefined) {
                  _this2.setState({
                    stage: newStage,
                    form: _objectSpread(_objectSpread({}, form), validatedData)
                  });
                } else {
                  _this2.setState({
                    stage: newStage
                  });
                }

                setPrePurchaseRoute(_this2.getActiveRouteState(navigation.state).routeName); // Stage 3: API Requests

                if (!(newStage === 3)) {
                  _context.next = 64;
                  break;
                }

                cardNickname = undefined;

                if (form.saveCard || validatedData.saveCard) {
                  cardNickname = form.cardNickname ? form.cardNickname : validatedData.cardNickname;
                } // This persists with redux persist for when we reload


                setCardNickname(cardNickname);
                routeParams = {};
                activeRouteState = _this2.getActiveRouteState(navigation.state);
                activeRouteStateParams = activeRouteState.params || {};
                gid = activeRouteStateParams.gid;

                if (gid !== undefined) {
                  routeParams[RouteParamConstants.PARAM_GAME_ID] = gid;
                }

                routeParams[RouteParamConstants.PARAM_PURCHASE_TYPE] = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_TYPE, undefined);
                routeParams[RouteParamConstants.PARAM_PURCHASE_SKU] = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_SKU, undefined);
                routeParams.packageDetail = statePackage;
                setPrePurchaseRouteParams(routeParams);

                if (typeof promoReward === 'object') {
                  setPromoCode(promoCode);
                } else {
                  setPromoCode(undefined);
                }

                _ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : PurchaseTypes.CONSUMABLE;
                billingInfo = _this2.getBillingInfoBasedOnClient(validatedData, form);
                _buyItemParams = {
                  ptype: _ptype,
                  currpkgid: packageId,
                  redirecturl: redirecturl,
                  billing: billingInfo,
                  // Not required
                  firstname: undefined,
                  lastname: undefined,
                  year: undefined,
                  month: undefined,
                  day: undefined
                };

                if (dynamicTriggeredSaleId > 0) {
                  _buyItemParams.saleId = dynamicTriggeredSaleId;
                }

                _context.t0 = _this2.props.paymentProvider;
                _context.next = _context.t0 === PaymentProviders.CAMS ? 51 : _context.t0 === PaymentProviders.EWAY ? 53 : 54;
                break;

              case 51:
                if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET !== 'star') {
                  ShopInterface.buyItem.sendDataToCAMS(_buyItemParams, formUrl);
                } else {
                  ShopInterface.buyItem.buyItem(_buyItemParams);
                }

                return _context.abrupt("break", 63);

              case 53:
                return _context.abrupt("break", 63);

              case 54:
                _buyItemParams.address1 = form.billingInfoAddress;
                _buyItemParams.address2 = form.billingInfoAddress2;
                _buyItemParams.city = form.billingInfoCity;
                _buyItemParams.country = form.billingInfoCountry;
                _buyItemParams.state = form.billingInfoState;
                _buyItemParams.zip = form.billingInfoZip;

                if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'ti' && KYCResult !== KYC_STATUS.PASS) {
                  _buyItemParams.firstname = form.billingInfoFirstname;
                  _buyItemParams.lastname = form.billingInfoLastname;
                  _buyItemParams.year = form.billingInfoYear;
                  _buyItemParams.month = form.billingInfoMonth;
                  _buyItemParams.day = form.billingInfoDay;
                }

                ShopInterface.buyItem.buyItem(_buyItemParams);
                return _context.abrupt("break", 63);

              case 63:
                if (statePackage && statePackage.OFFER_ID) {
                  try {
                    InboxMessagesProvider.removeMessage(statePackage.OFFER_ID);
                  } catch (e) {
                    console.error(e);
                  }
                }

              case 64:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this2.getBillingInfoBasedOnClient = function (validatedData, form) {
      if (_this2.props.paymentProvider === PaymentProviders.CAMS && Utils.getPlatform() === 'web') {
        if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET !== 'star') {
          return {
            cc: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardNumber) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardNumber),
            cvv: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardCVV) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardCVV),
            expiryMonth: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryMonth) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardExpiryMonth),
            expiryYear: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryYear) || (validatedData === null || validatedData === void 0 ? void 0 : validatedData.cardExpiryYear)
          };
        } else {
          return {
            cc: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardNumber) || (form === null || form === void 0 ? void 0 : form.cardNumber),
            cvv: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardCVV) || (form === null || form === void 0 ? void 0 : form.cardCVV),
            expiryMonth: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryMonth) || (form === null || form === void 0 ? void 0 : form.cardExpiryMonth),
            expiryYear: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryYear) || (form === null || form === void 0 ? void 0 : form.cardExpiryYear)
          };
        }
      } else {
        return {
          cc: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardNumber) || (form === null || form === void 0 ? void 0 : form.cardNumber),
          cvv: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardCVV) || (form === null || form === void 0 ? void 0 : form.cardCVV),
          expiryMonth: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryMonth) || (form === null || form === void 0 ? void 0 : form.cardExpiryMonth),
          expiryYear: (validatedData === null || validatedData === void 0 ? void 0 : validatedData.billingInfoCardExpiryYear) || (form === null || form === void 0 ? void 0 : form.cardExpiryYear)
        };
      }
    };

    _this2.getBuyItemDetails = function () {
      var billingInfo = {};
      var redirecturl = "https://".concat(window.location.hostname, "/").concat(Screens.FinishWebPurchase, "?fix=me");

      if (window.location.hostname === 'localhost') {
        redirecturl = "https://".concat(window.location.hostname, ":3000/").concat(Screens.FinishWebPurchase, "?fix=me");
      }

      var buyItemParams = {
        ptype: _this2.state.purchaseType,
        currpkgid: _this2.state.packageId,
        redirecturl: redirecturl,
        billing: billingInfo,
        // Not required
        firstname: undefined,
        lastname: undefined,
        year: undefined,
        month: undefined,
        day: undefined
      };

      if (_this2.state.dynamicTriggeredSaleId > 0) {
        buyItemParams.saleId = _this2.state.dynamicTriggeredSaleId;
      }

      return buyItemParams;
    };

    _this2.LoadBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var billingInfo, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this2.props.paymentProvider === PaymentProviders.EWAY)) {
                _context2.next = 8;
                break;
              }

              billingInfo = _this2.getBuyItemDetails();
              _context2.next = 4;
              return ShopInterface.buyItem.buyItem(billingInfo);

            case 4:
              response = _context2.sent;

              _this2.props.setFormUrl(response.formurl);

              _this2.props.setAccessCode(response.accessCode);

              _this2.props.setTransactionId(response.transactionid);

            case 8:
              if (_this2.props.paymentProvider === PaymentProviders.CAMS && Utils.getPlatform() === 'web' && _this2.props.purchaseProfile.length === 0) {
                if (_this2.state.stage === 1 && ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'sga') {
                  _this2.props.showCustomModal(true);
                }
              }

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this2.getActiveRouteState = function (route) {
      if (!route.routes || route.routes.length === 0 || route.index >= route.routes.length) {
        return route;
      }

      var childActiveRoute = route.routes[route.index];
      return _this2.getActiveRouteState(childActiveRoute);
    };

    _this2.buyWithBillingProfile = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(pid) {
        var _store$getState$gameI;

        var active_game_id, trigger_id, _this2$state2, purchaseType, packageId, statePackage, ptype, _this2$props2, promoLink, isOutOfCoinsPurchase, transactionUUID, ltoPurchase, isLTOPurchase, clearLTOOffer, coin, level, loyalty, gameInfo, params, result, trigger, platform, _store, loggerParams;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                active_game_id = ((_store$getState$gameI = store.getState().gameInfo) === null || _store$getState$gameI === void 0 ? void 0 : _store$getState$gameI.gameId) || null;
                trigger_id = store.getState().purchase.actionTrigger;
                _this2$state2 = _this2.state, purchaseType = _this2$state2.purchaseType, packageId = _this2$state2.packageId, statePackage = _this2$state2.package;

                if (!(pid === -1)) {
                  _context3.next = 8;
                  break;
                }

                _this2._nextHandle(true);

                ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'sga' && _this2.props.showCustomModal(true);
                _context3.next = 30;
                break;

              case 8:
                if (!(pid >= 0)) {
                  _context3.next = 30;
                  break;
                }

                _this2.setState({
                  stage: 3
                });

                _this2.props.showCustomModal(false);

                ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : PurchaseTypes.CONSUMABLE;
                _this2$props2 = _this2.props, promoLink = _this2$props2.promoLink, isOutOfCoinsPurchase = _this2$props2.isOutOfCoinsPurchase, transactionUUID = _this2$props2.transactionUUID, ltoPurchase = _this2$props2.ltoPurchase, isLTOPurchase = _this2$props2.isLTOPurchase, clearLTOOffer = _this2$props2.clearLTOOffer, coin = _this2$props2.coin, level = _this2$props2.level, loyalty = _this2$props2.loyalty, gameInfo = _this2$props2.gameInfo;
                params = {
                  ptype: ptype,
                  currpkgid: packageId,
                  profile: pid,
                  messageId: statePackage.OFFER_ID || null
                };

                if (promoLink && promoLink.active && !statePackage.OFFER_ID) {
                  params.promocode = promoLink.code;
                }

                _context3.next = 17;
                return ShopInterface.buyItemWithBillingProfile(_objectSpread(_objectSpread({}, params), {}, {
                  active_game_id: active_game_id,
                  trigger_id: trigger_id
                }));

              case 17:
                result = _context3.sent;
                trigger = Logger.getActionTrigger();
                platform = Utils.getPlatform();
                _context3.t0 = platform;
                _context3.next = _context3.t0 === 'web' ? 23 : _context3.t0 === 'ios' ? 25 : 27;
                break;

              case 23:
                _store = 'cams';
                return _context3.abrupt("break", 28);

              case 25:
                _store = 'appstore';
                return _context3.abrupt("break", 28);

              case 27:
                _store = platform;

              case 28:
                loggerParams = {
                  amount: statePackage.PRICE || statePackage.price,
                  product_id: packageId,
                  type: purchaseType === PurchaseTypes.CURRENCY ? 'regular' : 'vip',
                  currency: 'usd',
                  store: _store,
                  trigger: trigger,
                  store_tx_id: result.transaction_id,
                  id: transactionUUID,
                  tx_error: result.error,
                  promo_code: params.promocode,
                  game_id: gameInfo.gameId,
                  game_provider: gameInfo.gameProvider,
                  product_name: statePackage.NAME,
                  loyalty_points: statePackage.BONUS_LOYALTY_AMOUNT,
                  loyalty_points_before: loyalty.value,
                  level_after: level,
                  coins: statePackage.AMOUNT,
                  promo_coins: statePackage.AMOUNT_INCLUDING_SALE_AND_PROMO,
                  balance_before: coin.value
                };

                if (result.success) {
                  _this2.setState({
                    stage: 4
                  });

                  Logger.sendEvent(EVENT_TYPES.PURCHASE_COMPLETE, loggerParams);
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));
                  isOutOfCoinsPurchase(false);
                  ltoPurchase && clearLTOOffer();
                  isLTOPurchase(false);
                  ShopInterface.refreshActiveConsumables();

                  if (statePackage && statePackage.OFFER_ID) {
                    try {
                      InboxMessagesProvider.removeMessage(statePackage.OFFER_ID);
                    } catch (e) {
                      console.error(e);
                    }
                  }
                } else {
                  Logger.sendEvent(EVENT_TYPES.TRANSACTION_FAILED, loggerParams);

                  _this2.setState({
                    stage: 5
                  });
                }

              case 30:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this2.checkPromoCode = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(code) {
        var packageId, response, eventPayload;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                packageId = _this2.state.packageId;

                if (!(code === '')) {
                  _context4.next = 5;
                  break;
                }

                _this2.setState({
                  promoReward: getText(TEXT_KEY.YOU_MUST_ENTER_A_PROMO_CODE)
                });

                _context4.next = 10;
                break;

              case 5:
                _this2.setState({
                  promoReward: undefined,
                  promoCode: code
                });
                /** @type {import("../../api/Constants").CheckPromoCodeResponse} */


                _context4.next = 8;
                return ShopInterface.checkPromoCode(code, 'purchase', packageId);

              case 8:
                response = _context4.sent;

                if (response.success) {
                  _this2.setState({
                    promoReward: response.redeem
                  });
                } else {
                  _this2.setState({
                    promoReward: response.error
                  });

                  eventPayload = {
                    description: "Promo code ".concat(code, " claim failed, ").concat(response.error),
                    code: 28
                  };
                  Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
                }

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this2.deleteBillingProfile = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(pid) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return ShopInterface.removeBillingProfile(pid);

              case 2:
                _this2.props.setPurchaseProfile(_this2.props.purchaseProfile.filter(function (profile) {
                  return String(profile.profile_id) !== String(pid);
                }));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this2.contactSupport = function () {
      var _QueryParamsProxy$set2;

      _this2.props.dismissPurchase();

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set2 = {}, _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_MODAL, Screens.Settings), _defineProperty(_QueryParamsProxy$set2, RouteParamConstants.PARAM_SETTINGS_SCREEN, SettingsScreensEnum.customerSupport), _QueryParamsProxy$set2));
    };

    _this2.state = {
      validatedStage: 0,
      stage: _this2.props.purchaseProfile.length === 0 ? 1 : 0,
      package: null,
      packageId: '',
      packageName: '',
      purchaseType: '',
      offerDetail: null,
      dynamicTriggeredSaleId: 0,
      promoCode: undefined,
      promoReward: undefined,
      errorMessage: '',

      /** @type {import("../../api/Constants").BillingProfile[]|undefined} */
      form: {
        billingInfoAddress1: '',
        billingInfoAddress2: '',
        billingInfoCountry: '',
        billingInfoCity: '',
        billingInfoState: '',
        billingInfoZip: '',
        billingInfoCardType: '',
        billingInfoCardNumber: '',
        billingInfoCardExpiryMonth: '',
        billingInfoCardExpiryYear: '',
        billingInfoCardCVV: '',
        billingInfoCardNickname: '',
        billingInfoSaveCard: '',
        billingInfoPromoCode: '',
        billingInfoFirstname: '',
        billingInfoLastname: '',
        billingInfoYear: '',
        billingInfoMonth: '',
        billingInfoDay: ''
      }
    };
    _this2.state.packageId = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_SKU, null);
    _this2.state.purchaseType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_TYPE, null);
    _this2.state.packageName = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_NAME, null);
    _this2.state.offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);
    _this2.state.dynamicTriggeredSaleId = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_DTS_ID, null);

    var _result = QueryParamsProxy.findParam(RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, undefined);

    var isPlatformMobile = Utils.getPlatform() !== 'web';
    var findItemId = 'item_id';

    if (isPlatformMobile) {
      findItemId = 'sku';
    }

    var _this2$state3 = _this2.state,
        _purchaseType = _this2$state3.purchaseType,
        _dynamicTriggeredSaleId = _this2$state3.dynamicTriggeredSaleId,
        _packageId = _this2$state3.packageId,
        offerDetail = _this2$state3.offerDetail;
    var _this2$props3 = _this2.props,
        dynamicTriggeredSale = _this2$props3.dynamicTriggeredSale,
        outOfCoinsPurchase = _this2$props3.outOfCoinsPurchase,
        outOfCoins = _this2$props3.outOfCoins,
        shopList = _this2$props3.shopList,
        ltoOffer = _this2$props3.ltoOffer,
        _ltoPurchase = _this2$props3.ltoPurchase;

    switch (_purchaseType) {
      case PurchaseTypes.CURRENCY:
        if (_dynamicTriggeredSaleId > 0) {
          _this2.state.package = {
            AMOUNT: dynamicTriggeredSale.currOffering.amount,
            PRICE: dynamicTriggeredSale.currPrice
          };
        } else {
          findItemId = 'CURRENCY_ITEM_ID';

          if (isPlatformMobile) {
            findItemId = 'MOBILE_PRODUCT_IAP_ID';
          }

          if (outOfCoinsPurchase) {
            _this2.state.package = outOfCoins;
          } else if (_ltoPurchase) {
            _this2.state.package = ltoOffer;
          } else if (offerDetail) {
            _this2.state.package = {
              AMOUNT: offerDetail.amount,
              PRICE: offerDetail.price,
              CURRENCY_ITEM_ID: offerDetail.cpil_id,
              OFFER_ID: offerDetail.messageId
            };
          } else {
            _this2.state.package = shopList.coins.find(function (item) {
              return item[findItemId] === _packageId;
            });
          }
        }

        break;

      case PurchaseTypes.VIP:
      case PurchaseTypes.CONSUMABLE:
        _this2.state.package = shopList.vip.find(function (item) {
          return item[findItemId] === _packageId;
        });
        break;

      default:
        console.error('Invalid pruchaseType.');
    } // If there's a purchase result


    if (_result !== undefined) {
      // Check the status, then go to the right stage
      if (_result === PurchaseFinishedResults.SUCCESS) {
        _this2.state.stage = 4;
      } else {
        _this2.state.stage = 5;
      }
    } else {
      // No purchase result yet
      // Get available billing profiles
      _this2.LoadBillingProfile();
    }

    return _this2;
  }

  _inherits(PurchaseFlow, _Component);

  return _createClass(PurchaseFlow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state = this.state,
          statePackage = _this$state.package,
          purchaseType = _this$state.purchaseType,
          packageId = _this$state.packageId;
      var mobileHandle = this.props.mobileHandle;

      if (mobileHandle) {
        var ptype = purchaseType === PurchaseTypes.CURRENCY ? PurchaseTypes.CURRENCY : PurchaseTypes.CONSUMABLE;
        mobileHandle(packageId, ptype, statePackage);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _QueryParamsProxy$set3;

      // set initiatePurchase to false, used on mobile to mount PurchaseFlow in LobbyOverlay
      this.props.dismissPurchase();
      this.props.showCustomModal(false);
      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set3 = {}, _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_SKU, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_TYPE, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_NAME, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_MSG, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_FINISHED_RESULT, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_PURCHASE_DTS_ID, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_OFFER_DETAIL, undefined), _QueryParamsProxy$set3));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          shopList = _this$props.shopList,
          gameInfo = _this$props.gameInfo,
          target = _this$props.target,
          shouldShowCustomModal = _this$props.shouldShowCustomModal,
          assetsUrls = _this$props.assetsUrls,
          formUrl = _this$props.formUrl,
          accessCode = _this$props.accessCode;
      var _this$state2 = this.state,
          validatedStage = _this$state2.validatedStage,
          stage = _this$state2.stage,
          purchaseType = _this$state2.purchaseType,
          packageId = _this$state2.packageId,
          packageName = _this$state2.packageName,
          promoReward = _this$state2.promoReward,
          statePackage = _this$state2.package,
          errorMessage = _this$state2.errorMessage;
      return render( // Pass state and handlers to platform renderer
      {
        validationStage: validatedStage,
        stage: stage,
        nextHandle: this._nextHandle,
        coinList: shopList.coins,
        vipList: shopList.vip,
        purchaseType: purchaseType,
        sku: packageId,
        packageName: packageName,
        buyWithBillingProfile: this.buyWithBillingProfile,
        deleteBillingProfile: this.deleteBillingProfile,
        checkPromoCode: this.checkPromoCode,
        promoReward: promoReward,
        profiles: this.props.purchaseProfile,
        packageData: statePackage,
        dismissPurchase: this.props.dismissPurchase,
        contactSupport: this.contactSupport,
        gameInfo: gameInfo,
        offerDetail: this.state.offerDetail,
        target: target,
        errorMessage: errorMessage,
        shouldShowCustomModal: shouldShowCustomModal,
        termsAndConditionsUrl: assetsUrls ? assetsUrls.termsAndConditions : '',
        formUrl: formUrl,
        accessCode: accessCode
      });
    }
  }]);
}(Component);

export { PurchaseFlow as default };
PurchaseFlow.propTypes = {
  outOfCoinsPurchase: PropTypes.any.isRequired,
  outOfCoins: PropTypes.any.isRequired,
  shopList: PropTypes.any.isRequired,
  mobileHandle: PropTypes.any,
  setCardNickname: PropTypes.any.isRequired,
  setPrePurchaseRoute: PropTypes.any.isRequired,
  navigation: PropTypes.any.isRequired,
  setPrePurchaseRouteParams: PropTypes.any.isRequired,
  setPromoCode: PropTypes.any.isRequired,
  promoLink: PropTypes.object,
  isOutOfCoinsPurchase: PropTypes.any.isRequired,
  isLTOPurchase: PropTypes.any.isRequired,
  render: PropTypes.any.isRequired,
  transactionUUID: PropTypes.any.isRequired
};